class OutOfStockForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.emailInput = this.querySelector('#notify_email');
    this.responseWrapper = this.querySelector('#bisAppResponseWrapper');
    this.responseMessage = this.querySelector('#bisAppResponse');

    this.messageError = this.dataset.messageError || 'Please enter an email address';
    this.messageSuccess = this.dataset.messageSuccess;

    this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener('submit', (ev) => {
      ev.preventDefault();

      const email = this.emailInput.value;
      const productId = document.querySelector('product-form input[name="product-id"]').value;
      const variantId = document.querySelector('product-form input[product-variant-id]').value;

      if (!email) {
        this.responseMessage.textContent = this.messageError;
        this.responseWrapper.className = 'text-red';
        return;
      }

      window.BIS.create(email, variantId, productId)
        .then((data) => {
          if (data.status === 'OK') {
            this.responseWrapper.classList.remove('hidden', 'text-red');
            this.responseMessage.textContent = this.messageSuccess || data.message;
          } else {
            let msg = '';
            for (let k in data.errors) {
              msg += data.errors[k].join();
            }
            this.responseMessage.textContent = msg;
            this.responseWrapper.className = 'text-red';
          }
          this.responseWrapper.classList.remove('hidden');
        })
        .catch((error) => {
          this.responseMessage.textContent = 'Error processing your request';
          this.responseWrapper.className = 'text-red';
          this.responseWrapper.classList.remove('hidden');
        });
    });
  }
}

customElements.define('out-of-stock-form', OutOfStockForm);
